import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.epsilon.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { EventBus } from "@/js/events/bus.js";
import { listCurrencies } from "@/js/lists.ts";
var CURRENCIES = "currencies";
export function getSymbolCurrency(currency) {
  return listCurrencies.find(function (x) {
    return x.id == currency;
  }).symbol;
}
export function getImplantedCurrencies() {
  return listCurrencies.filter(function (x) {
    return x.implanted_market;
  });
}
export function initStoredCurrencies() {
  if (!localStorage.getItem(CURRENCIES)) {
    var localCurs = listCurrencies.filter(function (x) {
      return x.implanted_market;
    }).map(function (x) {
      return {
        id: x.id,
        symbol: x.symbol,
        name: x.name,
        rate: x.id === "EUR" ? 1.0 : null,
        isUsedForCartAndExplore: x.id === "EUR"
      };
    });
    localStorage.setItem(CURRENCIES, JSON.stringify(localCurs));
  }
}
export function getStoredCurrencies() {
  if (!localStorage.getItem(CURRENCIES)) {
    initStoredCurrencies();
  }
  return JSON.parse(localStorage.getItem(CURRENCIES));
}
export function getStoredCurrency(currency) {
  return getStoredCurrencies().find(function (x) {
    return x.id === currency;
  });
}
export function getStoredCurrencyRate(_x) {
  return _getStoredCurrencyRate.apply(this, arguments);
}
function _getStoredCurrencyRate() {
  _getStoredCurrencyRate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(currency) {
    var localCur, rate;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          localCur = getStoredCurrency(currency);
          if (localCur.rate) {
            _context.next = 6;
            break;
          }
          _context.next = 4;
          return requestCurrencyRate(currency);
        case 4:
          rate = _context.sent;
          setLocalCurrencyRate(currency, rate);
        case 6:
          return _context.abrupt("return", +localCur.rate);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getStoredCurrencyRate.apply(this, arguments);
}
export function setStoredCurrencyRate(currency, rate) {
  var localCurs = getStoredCurrencies();
  localCurs.find(function (x) {
    return x.id === currency;
  }).rate = rate;
  localStorage.setItem(CURRENCIES, JSON.stringify(localCurs));
}
export function getCurrencyUsedForCartAndExplore() {
  return getStoredCurrencies().find(function (x) {
    return x.isUsedForCartAndExplore;
  });
}
export function getIdCurrencyUsedForCartAndExplore() {
  return getCurrencyUsedForCartAndExplore().id;
}
export function setCurrencyUsedForCartAndExplore(_x2) {
  return _setCurrencyUsedForCartAndExplore.apply(this, arguments);
}
function _setCurrencyUsedForCartAndExplore() {
  _setCurrencyUsedForCartAndExplore = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(currency) {
    var localCurs, localCur, rate;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          localCurs = getStoredCurrencies();
          localCur = localCurs.find(function (x) {
            return x.id === currency;
          });
          if (localCur.rate) {
            _context2.next = 12;
            break;
          }
          _context2.prev = 3;
          _context2.next = 6;
          return requestCurrencyRate(currency);
        case 6:
          rate = _context2.sent;
          localCur.rate = rate;
          _context2.next = 12;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](3);
        case 12:
          localCurs.find(function (x) {
            return x.isUsedForCartAndExplore;
          }).isUsedForCartAndExplore = false;
          localCur.isUsedForCartAndExplore = true;
          localStorage.setItem(CURRENCIES, JSON.stringify(localCurs));
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 10]]);
  }));
  return _setCurrencyUsedForCartAndExplore.apply(this, arguments);
}
export function getCurrencyUser() {
  return request("/v1/user/currency", "get", null, true, "api").then(function (response) {
    return response;
  }).catch(function (e) {
    return e;
  });
}
function requestCurrencyRate(currency) {
  if (currency === "USD" || currency === "BSD") return 1.2;
  if (currency === "EUR") return 1.0;
  var url = process.env.VUE_APP_CURRENCIES_URL;
  url += currency;
  return axios({
    method: "GET",
    url: url
  }).then(function (response) {
    if (response.status == 200) {
      var rate = response.data.rates[currency];
      return rate;
    }
  }).catch(function (e) {
    return e;
  });
}
export function getPriceValueInUsedCurrencyForCartAndExplore(euroValue) {
  var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var currency = getCurrencyUsedForCartAndExplore();
  var currencyRate = isNaN(currency === null || currency === void 0 ? void 0 : currency.rate) ? 1 : currency.rate;
  return (Math.round(euroValue * 100) / 100 * currencyRate).toFixed(2) * multiplier;
}
export function formatEurPriceInUsedCurrencyForCartAndExplore(euroValue) {
  var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var withSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var priceCurrency = getPriceValueInUsedCurrencyForCartAndExplore(euroValue, multiplier);
  var result = formatPrice(priceCurrency);
  if (withSymbol) {
    var currency = getCurrencyUsedForCartAndExplore();
    return result + " " + currency.symbol;
  } else {
    return result;
  }
}
export function formatPrice(value) {
  if (isNaN(value) && typeof value === "string") {
    value = value.replace(",", "");
  }
  value = parseFloat(value).toFixed(2);
  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return formatter.format(value);
}
export function displayPrice(priceCurrency) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "EUR";
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var withSymbol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var result = formatPrice(priceCurrency * multiplier);
  if (withSymbol) {
    return result + " " + getSymbolCurrency(currency);
  } else {
    return result;
  }
}
export function roundToTwoDigit(value) {
  value = Math.round(value * 1000 + Number.EPSILON) / 1000;
  value = parseFloat(value.toFixed(2));
  return value;
}

/*
VERY OLD VERSION FOR RETRO-COMPATIBILITY
*/
export function setCurrentRate(currency, rate) {
  listCurrencies.filter(function (x) {
    return x.implanted_market && x.id !== currency;
  }).forEach(function (y) {
    removeCurrency(y.id);
  });
  localStorage.setItem(currency, rate);
}
export function getCurrentRate(currency) {
  if (currency === "USD" || currency === "BSD") return 1.2;
  if (localStorage.getItem(currency)) return parseFloat(localStorage.getItem(currency));
  if (currency != "EUR") {
    return requestCurrencyRate(currency).then(function (response) {
      setCurrentRate(currency, response);
      return response;
    }).catch(function () {
      EventBus.$emit("loading", false);
    });
  } else {
    return 1;
  }
}
export function removeCurrency(currency) {
  localStorage.removeItem(currency);
}